module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markup-popup-form"
  }, [_c('div', {
    staticClass: "markup-popup-form__content"
  }, [_c('form', {
    attrs: {
      "action": _vm.formActionResolved,
      "method": "post"
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('PanelDashed', {
    staticClass: "markup-popup-form__form"
  }, [_vm._t("default")], 2), (!_vm.hideButton) ? _c('div', {
    staticClass: "markup-popup-form__buttons"
  }, [_c('FormButton', {
    staticClass: "markup-popup-form__button",
    attrs: {
      "disabled": _vm.disabled,
      "rounded": true,
      "color": _vm.buttonColor,
      "size": "medium",
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  })]), _vm._t("buttons")], 2) : _vm._e()], 1)]), (_vm.hasMessages) ? _c('div', _vm._l((_vm.messagesList), function(message, index) {
    return _c('MessageNotification', {
      key: index,
      attrs: {
        "items": message.items,
        "variant": message.variant
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a34ecec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/markup/popup/form/component.vue
// module id = 5a5c0e73312c5930438a
// module chunks = 89